export class PlayerTokenRefresh {
  constructor(options){
    this._tech = options.tech;
    this._data = options.data;
  }

  data(){
    return this._data;
  }

  tech(){
    return this._tech;
  }

  init(){
    this.bindTokenTimeout();
    this.bindClearTokenTimeout();
  }

  tokenDuration(){
    let duration = this.data().tokenDuration();
    duration = duration >= this.minutesToSeconds(20) ? duration - this.minutesToSeconds(10) : duration;
    return duration * 1000;
  }

  bindTokenTimeout(){
    this._tokenTimeout = window.setInterval(this.triggerRefreshPlayer.bind(this), this.tokenDuration());
  }

  bindClearTokenTimeout() {
    this.tech().on('vp-restart', this.clearTokenTimeout.bind(this));
    this.tech().on('dispose', this.clearTokenTimeout.bind(this));
  }

  clearTokenTimeout() {
    window.clearInterval(this._tokenTimeout);
  }

  triggerRefreshPlayer() {
    this.clearTokenTimeout();
  
    if(this.data().isPremier()) this.refreshUrlSource();
    else this.refreshPlayer();
  }

  refreshUrlSource() {
    const requestUrl = `/interactions_stream.json?video_id=${ this.data().videoId() }&type=${ this.getContentType() }`;
    let client = new XMLHttpRequest();
    client.onload = () => {
      const response = JSON.parse(client.responseText);
      this.setVjsClipHlsUrl(response.source);
      this.setVjsClipDashUrl(response.source_dash);
      this.refreshPlayer();
    };
    client.open('GET', requestUrl);
    client.send(null);

  }

  refreshPlayer(){
    this.increaseDataTokenRefreshCount();
    this.tech().trigger('vp-token-refresh');
    this.tech().trigger('vp-restart');
  }

  getContentType(){
    return this.data().isVideo() ? 'videos' : 'livestreamings';
  }

  setVjsClipHlsUrl(newSource){
    this.data().el().setAttribute('data-vjs-clip-hls-url', newSource);
  }

  setVjsClipDashUrl(newSource){
    if(newSource) this.data().el().setAttribute('data-vjs-clip-dash-url', newSource);
  }

  increaseDataTokenRefreshCount(){
    this.data().el().setAttribute('data-vod-token-refresh-count', this.data().tokenRefreshCount() + 1);
  }

  minutesToSeconds(minutes){
    return minutes * 60;
  }
}
